import { render, staticRenderFns } from "./InterestFollowUpInfo.vue?vue&type=template&id=ed5541ee&"
import script from "./InterestFollowUpInfo.vue?vue&type=script&lang=js&"
export * from "./InterestFollowUpInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports